import { useTranslation } from "react-i18next";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { Badge, Grid } from "@mui/material";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import DatePickerCustomDay from "components/DatePickerCustomDay";
import DatePickerCustomHeaderTwoMonth from "components/DatePickerCustomHeaderTwoMonth";
import DatePicker from "react-datepicker";
import useHomeAvailabilityCalendar from "hooks/useHomeAvailabilityCalendar";
import Sheet from "react-modal-sheet";
import moment from "moment";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { convertHoursToDays } from "utils/convertHoursToDisplayString";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { isWithinDateRange } from "utils/dateUtil";
import ModalReserveMobile from "./ModalReserveMobile";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonThird from "shared/Button/ButtonThird";

export default function HomeAvailabilityCalendar() {
  const { t } = useTranslation();

  const { startTime, endTime, totalHours, totalPrice, selectedDateBlock, highligtedDates, _onDayPress, _onClearSelectedDate, _onMonthChange, _onSelectTimeSlot } = useHomeAvailabilityCalendar();

  return (
    <div className="listingSection__wrap">
      <div>
        <h2 className="text-2xl font-semibold">{t("review")}</h2>
        <span className="block mt-2 text-neutral-500 dark:text-neutral-400">{t("review_desc")}</span>
      </div>
      <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>

      <div className="">
        <DatePicker
          onMonthChange={_onMonthChange}
          onSelect={_onDayPress}
          minDate={new Date()}
          onChange={() => {}}
          startDate={new Date()}
          endDate={new Date()}
          selectsRange
          monthsShown={2}
          showPopperArrow={false}
          highlightDates={highligtedDates}
          inline
          renderCustomHeader={(p) => <DatePickerCustomHeaderTwoMonth {...p} />}
          renderDayContents={(day, date) => <DatePickerCustomDay dayOfMonth={day} date={date} />}
        />
      </div>
      <Sheet isOpen={selectedDateBlock} onClose={_onClearSelectedDate} detent="content-height">
        <Sheet.Container>
          <Sheet.Header></Sheet.Header>
          <Sheet.Content>
            <div style={{ padding: 10, marginBottom: 20 }}>
              <h2 className="text-xl font-semibold" style={{ textAlign: "center" }}>
                {selectedDateBlock && moment(selectedDateBlock.slots[0].start_time).format("YYYY-MM-DD")} / {!startTime ? t("select_start_time") : !endTime && t("select_end_time")}
                {startTime && endTime && t("select_start_time")}
              </h2>

              {/* <h2 className="text-2xl font-semibold">
              </h2> */}
              {/* <span className="block mt-2 mb-2 text-neutral-500 dark:text-neutral-400">
                {t("quick_selection_desc")} : ( {selectedDateBlock ? selectedDateBlock.availability : ""} ) {t("selection_unit")}
              </span> */}

              <div className="mt-6 border border-neutral-200 dark:border-neutral-700 rounded-3xl flex flex-col sm:flex-row divide-y sm:divide-x sm:divide-y-0 divide-neutral-200 dark:divide-neutral-700 overflow-hidden z-10">
                <div className="text-left flex-1 p-5 flex justify-between space-x-5 hover:bg-neutral-50 dark:hover:bg-neutral-800">
                  <div className="flex flex-col">
                    <span className="text-sm text-neutral-400">{t("startTime")}</span>
                    <span className="mt-1.5 text-lg text-neutral-600">
                      {startTime ? moment(startTime).format("YY/MM/DD HH:mm") : "--"} {t("to")} {endTime ? moment(endTime).format("YY/MM/DD HH:mm") : "--"}
                    </span>
                    <br />
                    <span className="text-sm text-neutral-400">{t("totalTime")}</span>
                    <span className="mt-1.5 text-lg text-neutral-600">{totalHours ? convertHoursToDays(totalHours) : "--"}</span>
                  </div>
                </div>
              </div>
            </div>

            <Sheet.Scroller>
              <Grid container direction="row" spacing={0} justifyContent="space-evenly" padding={1}>
                {selectedDateBlock && selectedDateBlock?.slots?.map((item: any) => <DisplayBlocks item={item} _onSelectTimeSlot={_onSelectTimeSlot} />)}
              </Grid>
            </Sheet.Scroller>
            <Grid container justifyContent="center" alignItems="center">
              <ButtonPrimary sizeClass="mt-2 mb-2 py-3 w-[50%]" onClick={_onClearSelectedDate}>
                {t("confirm")}
              </ButtonPrimary>
            </Grid>
          </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop onTap={_onClearSelectedDate} />
      </Sheet>
    </div>
  );
}

const DisplayBlocks = ({ item, _onSelectTimeSlot }: any) => {
  const { startTime, endTime } = useSelector((state: RootState) => state.price);

  const bgColor = item.isOccupied ? { backgroundColor: "rgb(240, 240, 240)" } : {};

  const fontColor = item.isOccupied ? {} : {};

  let isStartTimeMatch = item.start_time === startTime;

  let isEndTimeMatch = item.end_time === endTime;

  let defaultStyle: any = {
    fontColor: null,
    backgroundColor: null,
  };

  if (startTime && !endTime) {
    defaultStyle = isWithinDateRange(startTime, startTime, item.start_time)
      ? {
          fontColor: "text-white",
          backgroundColor: "bg-primary-6000",
          // backgroundColor: "#138f00fd",
        }
      : {
          fontColor: null,
          backgroundColor: null,
        };
  }

  if (startTime && endTime) {
    defaultStyle =
      isWithinDateRange(startTime, endTime, item.start_time) && isWithinDateRange(startTime, endTime, item.end_time)
        ? {
            fontColor: "text-white",
            backgroundColor: "bg-primary-6000",
            // backgroundColor: "#138f00fd",
          }
        : {
            fontColor: null,
            backgroundColor: null,
          };
  }

  return (
    <a
      onClick={() => {
        if (!item.isOccupied) {
          _onSelectTimeSlot(item);
        }
      }}
      style={{ width: "45%" }}>
      <Grid
        key={item.start_time}
        className={defaultStyle.backgroundColor}
        item
        style={{ borderWidth: 1, marginBottom: 20, borderRadius: 20, padding: 10, ...bgColor }}
        justifyContent="center"
        alignItems="center">
        <i className={`text-xl text-neutral-500 las la-clock mr-2 ${defaultStyle?.fontColor}`}></i>
        <span className={`${defaultStyle?.fontColor} mt-2 text-neutral-500 dark:text-neutral-400`} style={{ ...fontColor }}>
          {isStartTimeMatch && `${moment(item.start_time).format("HH:mm")} - ${moment(item.end_time).format("HH:mm")}`}
          {isEndTimeMatch && `${moment(item.start_time).format("HH:mm")} - ${moment(item.end_time).format("HH:mm")}`}
          {!isStartTimeMatch && !isEndTimeMatch && (
            <>
              {!startTime ? `${moment(item.start_time).format("HH:mm")}` : !endTime && `${moment(item.end_time).format("HH:mm")}`}
              {startTime && endTime && `${moment(item.start_time).format("HH:mm")}`}
            </>
          )}
          {/* {!isStartTimeMatch && !isEndTimeMatch && <>{!endTime ? `${moment(item.end_time).format("HH:mm")}` : `${moment(item.start_time).format("HH:mm")}`}</>} */}
        </span>
      </Grid>
    </a>
  );
};
